import { ROLES } from "../../config/Roles.config";

// Sidebar menu structure
const SidebarMenus = [
  {
    label: "Home",
    icon: <span className="material-symbols-outlined">home</span>,
    path: "/",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Podcast",
    icon: <span className="material-symbols-outlined">mic</span>,
    path: "/podcast",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Bhakti Sangeet",
    icon: <span className="material-symbols-outlined">headphones</span>,
    path: "/bhakti-sangeet",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Educational Content",
    icon: <span className="material-symbols-outlined">book_2</span>,
    path: "/educational-topics",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Devotional News",
    icon: <span className="material-symbols-outlined">library_books</span>,
    path: "/devotional-news",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Information Section",
    icon: <span className="material-symbols-outlined">info</span>,
    path: "/information-section",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "E-books",
    icon: <span className="material-symbols-outlined">books_movies_and_music</span>,
    path: "/e-books",
    role: [ROLES.ADMIN, ROLES.USER],
  },
  {
    label: "Favorites",
    icon: <span className="material-symbols-outlined">bookmark</span>,
    path: "/favorite",
    role: [ROLES.ADMIN, ROLES.USER],
  },
];

export default SidebarMenus;
